/** Cross-layout workroom/project edit (Header modal ↔ ProjectViewPage). */
export const EDIT_WORKROOM_EVENT = "plambo:edit-workroom";
export const CREATE_WORKROOM_EVENT = "plambo:create-workroom";
export const WORKROOM_UPDATED_EVENT = "plambo:workroom-updated";
export const EDIT_PROJECT_EVENT = "plambo:edit-project";

/** Wizard steps in CreateWorkroomModal */
export const WORKROOM_STEP = {
  CONCEPT: 0,
  NAPKIN_BRIEF: 1,
  REFERENCE_IMAGES: 2,
};

/**
 * Ask Header to open CreateWorkroomModal in edit mode at a given step.
 * @param {{ workroom: object, step?: number }} detail
 */
export function dispatchEditWorkroom({ workroom, step = WORKROOM_STEP.CONCEPT } = {}) {
  if (!workroom) return;
  window.dispatchEvent(
    new CustomEvent(EDIT_WORKROOM_EVENT, {
      detail: { workroom, step },
    }),
  );
}

/**
 * Ask Header to open CreateWorkroomModal in create mode.
 * @param {{ projectId?: string|number, step?: number }} detail
 */
export function dispatchCreateWorkroom({ projectId = null, step = WORKROOM_STEP.CONCEPT } = {}) {
  window.dispatchEvent(
    new CustomEvent(CREATE_WORKROOM_EVENT, {
      detail: { projectId, step },
    }),
  );
}

export function dispatchWorkroomUpdated() {
  window.dispatchEvent(new CustomEvent(WORKROOM_UPDATED_EVENT));
}

/**
 * Ask Header to open CreateProjectModal in edit mode at a given step.
 * Used by the workroom timeline "edit timeline" control.
 * @param {{ projectId?: string|number|null, step?: number }} [detail]
 */
export function dispatchEditProject({ projectId = null, step = 0 } = {}) {
  window.dispatchEvent(
    new CustomEvent(EDIT_PROJECT_EVENT, {
      detail: { projectId: projectId ?? null, step },
    }),
  );
}
